var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"title-lable-error"},[_c('span',{staticClass:"ml-3"},[_vm._v("Invalid image state")])]),_c('div',{staticClass:"d-flex flex-row mt-3 ml-3",staticStyle:{"color":"#757575","font-size":"0.85rem"}},[_c('div',[_vm._v("Shutdown image cannot be scheduled in current state.")])])])
}]

export { render, staticRenderFns }